import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { initiativesTabs } from './../../constants/endpoint.constants';
import { InitiativeTab, InnovationAndProductivity } from 'src/app/interfaces/home.interface';
import { of } from 'rxjs';
import { ToasterService } from 'src/app/components/toast/toaster.service';
import { ApiErrorMessage } from 'src/app/enums/api-status.enum';

@Component({
  selector: 'app-innovation-productivity-page',
  templateUrl: './innovation-productivity-page.component.html',
  styleUrls: ['./innovation-productivity-page.component.scss']
})
export class InnovationProductivityPageComponent implements OnInit {
  public engagementId!: any;
  @Input() data: any = {
    'clientId': '',
    'isModal': false
  };
  public engagementsList: Array<any> = [];
  public selectedCompetency: string = 'All';
  public innovationAndProductivity!: InnovationAndProductivity[];
  multiSelectValues: Array<string>= [];
  selectedValueMultiple: Array<any> = [];
  initiativesData: InnovationAndProductivity[] = [];
  initiativesTabs: InitiativeTab[] = initiativesTabs;
  activeInitiativeType: InitiativeTab= {
    activeIcon: 'assets/images/inflights_active.svg',
    inActiveIcon: 'assets/images/inflights_inactive.svg',
    name: 'Inflight',
    count: 0,
    active: true,
  };
  innovationInflightLength: number = 0;
  innovationCompletedLength: number = 0;
  loading: boolean = false;

  constructor(private toasterServiceRef: ToasterService, private router: Router, private route: ActivatedRoute, private homeServiceRef: HomeService) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id'); //number or string
    this.loading = true;
    this.engagementId = id || this.data.clientId;
    console.log(this.engagementId);
    this.homeServiceRef.getInnovationAndProductivity(this.engagementId).subscribe({
      next: (res: InnovationAndProductivity[]) => {
        this.innovationAndProductivity = res;
        this.initiativesData = res.filter(
          (r: InnovationAndProductivity) => r.status === this.activeInitiativeType.name
        );
        this.innovationInflightLength = this.initiativesData.length;

        this.innovationCompletedLength = res.filter(
          (r: InnovationAndProductivity) => r.status === 'Completed'
        ).length;
        let map = new Map();

        // Removing duplicate objects using map in engagements list
        const arr= res.map((i) => { return { 'name': i.engagementName, 'id': i.engagementIdentifier } });
        arr.forEach((obj) => {
            const key = JSON.stringify(obj);
            if (!map.has(key)) {
                map.set(key, true);
                this.engagementsList.push(obj);
            }
        });


          this.loading = false;
      },
      error: (err) => {
        this.toasterServiceRef.error(ApiErrorMessage.DEFAULT);
        this.loading = false;
      },
    });
  }

  tabClickHandler(tab: InitiativeTab): void {
    this.activeInitiativeType = tab;
    tab.name === 'Inflight'
      ? (this.initiativesData = this.innovationAndProductivity.filter(
        (res) => res.status === 'Inflight'
      ))
      : (this.initiativesData = this.innovationAndProductivity.filter(
        (res) => res.status === 'Completed'
      ));
  }

  updateInitiatives(filter: string, tab:any) {
    // console.log(filter);    
    // console.log(this.multiSelectValues);
    // console.log(this.activeInitiativeType);
    if(filter === 'status' && tab){
      this.activeInitiativeType = tab;
    }
    let filteredData = structuredClone(this.innovationAndProductivity);
    if (this.multiSelectValues.length)
      this.initiativesData = filteredData.filter(
        (r: InnovationAndProductivity) => r.status === this.activeInitiativeType.name && (this.multiSelectValues.length&&this.multiSelectValues.includes(r.engagementIdentifier))
      );
    else
      this.initiativesData = filteredData.filter(
        (r: InnovationAndProductivity) => r.status === this.activeInitiativeType.name
      );
    console.log(this.initiativesData);
  }

  goHome() {
    this.router.navigate([`/home`, this.engagementId]);
  }

}
